import { Card, Stack, tokens } from '@cast/design-system';

type SettingsLayoutProps = {
  settingsRows: React.ReactNode;
  settingsContent: React.ReactNode;
  testId?: string;
  nextButton?: React.ReactNode;
  tabs?: React.ReactNode;
  headerSection?: React.ReactNode;
};

export const SettingsLayout = ({
  settingsRows,
  settingsContent,
  testId = 'settings-layout',
  nextButton,
  headerSection,
}: SettingsLayoutProps) => {
  return (
    <Stack
      display="grid"
      gridTemplateColumns="2fr 5fr"
      alignItems="flex-start"
      columnGap={24}
      data-testid={testId}
    >
      <Stack gap={8}>
        {headerSection && (
          <Card
            sx={{
              px: 0,
              border: '1px solid',
              borderColor: tokens.theme.border.structural.neutral,
            }}
          >
            {headerSection}
          </Card>
        )}
        <Card sx={{ px: 0 }}>
          <Stack>{settingsRows}</Stack>
        </Card>
      </Stack>
      {/* Setting Form */}
      <Stack gap={16}>
        <Card
          sx={{
            px: 24,
            pt: 16,
            pb: 38,
          }}
        >
          {settingsContent}
        </Card>
        {nextButton}
      </Stack>
    </Stack>
  );
};
